import P from '../../pages';
import React from 'react';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import Form from 'react-bootstrap/lib/Form';
import SelectGroup from './SelectGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import Home from 'react-icons/lib/md/home';
import ButtonGroup from './ButtonGroup';
import ProfileElementField from './ProfileElementField';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormDate from './FormDate';
import CustomFormGroup from './CustomFormGroup';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { generateProfileElementObject, formatDate, changeState, handleSelection } from '../../utilities';

class HouseContinued extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      livingInHomeSince: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'living_in_home_since'),
      numBedrooms: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'num_bedrooms'),
      squareFootage: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'square_footage'),
      homeFeatures: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, [], 'home', 'home_features'),
      householdNeighbourhoodInfo: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'household_neighbourhood_info'),
      homeInfo: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'', 'home', 'home_info'),
      numBedroomsSelections: this.props.localProfileElements.elements.home.num_bedrooms_selections,
      homeFeaturesSelections: this.props.localProfileElements.elements.home.home_features_selections,
      squareFootageSelections: this.props.localProfileElements.elements.home.square_footage_selections
    };
    this.back = this.back.bind(this);
    this.submit = this.submit.bind(this);
    this.changeState = this.changeState.bind(this);
    this.updateLivingInHomeSince = this.updateLivingInHomeSince.bind(this);
    this.handleHomeFeatures = this.handleHomeFeatures.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  updateLivingInHomeSince(date){
    this.changeState('livingInHomeSince', date);
  }

  handleHomeFeatures(e){
    this.changeState('homeFeatures', handleSelection(this.state.homeFeatures.val, e.target.value))
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit(
      {
        home: {
          living_in_home_since: formatDate(this.state.livingInHomeSince.val),
          num_bedrooms: this.state.numBedrooms.val,
          square_footage: this.state.squareFootage.val,
          household_neighbourhood_info: this.state.householdNeighbourhoodInfo.val,
          home_info: this.state.homeInfo.val,
          home_features: this.state.homeFeatures.val
        }
      }
    );
  }

  render() {
    const thisPage = P.HOUSE_CONTINUED_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>
        <form>
          <FormHeader title={content.pages.house_continued.title} icon={<Home />}/>
          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.livingInHomeSince.valid}>
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesHouseContinuedLabelsLivingInHomeSince)}</ControlLabel>
                <FormDate
                  updateDateState={this.updateLivingInHomeSince}
                  intl={this.props.intl}
                  date={formatDate(this.state.livingInHomeSince.val)} />
              </CustomFormGroup>
            }
            elementName='living_in_home_since' />
          <ProfileElementField
            childComponent={
              <SelectGroup
                style={{width: '40%'}}
                title={formatMessage(defaultMessages.clientHostPagesHouseContinuedLabelsNumBedrooms)}
                setId={'numBedrooms'}
                placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
                controlFunc={e => this.changeState(e.target.id, e.target.value)}
                options={this.state.numBedroomsSelections}
                defaultValue={this.state.numBedrooms.val}
                valid={this.state.numBedrooms.valid} />
            }
            elementName='num_bedrooms' />

          <ProfileElementField
            childComponent={
              <SelectGroup
                style={{width: '40%'}}
                title={formatMessage(defaultMessages.clientHostPagesHouseContinuedLabelsSquareFootage)}
                setId={'squareFootage'}
                placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
                controlFunc={e => this.changeState(e.target.id, e.target.value)}
                options={this.state.squareFootageSelections}
                defaultValue={this.state.squareFootage.val}
                valid={this.state.squareFootage.valid} />
            }
            elementName='square_footage' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.householdNeighbourhoodInfo.valid} >
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesHouseContinuedLabelsHouseholdNeighbourhoodInfo)}</ControlLabel>
                <FormControl
                  type="text"
                  id="householdNeighbourhoodInfo"
                  componentClass="textarea"
                  style={{width: '100%'}}
                  onChange={e => this.changeState(e.target.id, e.target.value)}
                  defaultValue={this.state.householdNeighbourhoodInfo.val} />
              </CustomFormGroup>
            }
            elementName='household_neighbourhood_info' />

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={formatMessage(defaultMessages.clientHostPagesHouseContinuedLabelsHomeFeatures)}
                setName={'homeFeatures'}
                type={'checkbox'}
                controlFunc={this.handleHomeFeatures}
                options={this.state.homeFeaturesSelections}
                selectedOptions={this.state.homeFeatures.val}
                valid={this.state.homeFeatures.valid} />
            }
            elementName='home_features' />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.homeInfo.valid} >
                <ControlLabel>{formatMessage(defaultMessages.clientHostPagesHouseContinuedLabelsHomeInfo)}</ControlLabel>
                <FormControl
                  type="text"
                  id="homeInfo"
                  componentClass="textarea"
                  style={{width: '100%'}}
                  onChange={e => this.changeState(e.target.id, e.target.value)}
                  defaultValue={this.state.homeInfo.val} />
              </CustomFormGroup>
            }
            elementName='home_info' />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />
        </form>
      </div>
    );
  }
}

export default injectIntl(HouseContinued);
